var _defs, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBorderLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 87,
    viewBox: "0 0 161 87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "border-left_svg__a",
    x1: "0%",
    x2: "15.077%",
    y1: "27.503%",
    y2: "46.215%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CB9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C59ED9",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 161,
    x: 1020,
    y: 156,
    fill: "none",
    stroke: "url(#border-left_svg__a)",
    strokeWidth: 2,
    rx: 8,
    transform: "translate(-1019 -155)"
  })));
}

export default SvgBorderLeft;